import { PlayCircleIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'
import { Typography } from '@/components/ui/typography'

import * as S from './tutorial-banner.styled'

interface TutorialBannerProps {
  description: string
  onButtonClick: () => void
  title: string
}

export const TutorialBanner = ({ description, onButtonClick, title }: TutorialBannerProps) => {
  const { t } = useTranslation(['common'])

  return (
    <S.Banner>
      <S.StarImage alt="" src="/images/Star3D.svg" />
      <S.TextContent>
        <Typography size="text-medium" weight="semibold">
          {title}
        </Typography>
        <Typography size="text-small" color="black500">
          {description}
        </Typography>
      </S.TextContent>
      <Button size="small" use="upsell" onClick={onButtonClick}>
        <Icon icon={PlayCircleIcon} size="1.6rem" />
        {t('common:actions.watchTutorial')}
      </Button>
    </S.Banner>
  )
}
